import React from "react";
import "../redesign.css";

const DocumentChecklist = ({ 
  esignedStatus, 
  enachStatus, 
  agreementGenerated, 
  agreementDownloadUrl, 
  onEsign, 
  onEnach, 
  onDownload 
}) => {
  return (
    <div className="oxy-card">
      <h5 className="fw-bold mb-4" style={{ color: "var(--oxy-on-surface)" }}>
        <i className="fa-solid fa-folder-closed text-primary me-2"></i>
        Required Onboarding Documents
      </h5>
      
      <div className="space-y-3">
        {/* Step 1: Agreement Ready */}
        <div className={`doc-checklist-item ${agreementGenerated ? "ready" : "pending"}`}>
          <div className="d-flex align-items-center gap-3">
            <div className={`rounded-circle p-2 d-flex align-items-center justify-content-center ${agreementGenerated ? "bg-success text-white" : "bg-warning text-dark"}`} style={{ width: "32px", height: "32px" }}>
              <i className={`fa-solid ${agreementGenerated ? "fa-check" : "fa-clock"}`}></i>
            </div>
            <div>
              <span className="fw-bold d-block" style={{ fontSize: "14px" }}>Loan Agreement Generation</span>
              <span className="text-muted small">{agreementGenerated ? "Agreement generated by legal team" : "Awaiting legal agreement generation"}</span>
            </div>
          </div>
          {agreementGenerated && agreementDownloadUrl && (
            <button className="btn btn-sm btn-outline-primary" onClick={onDownload}>
              <i className="fa-solid fa-download me-1"></i>Download
            </button>
          )}
        </div>

        {/* Step 2: eSign */}
        <div className={`doc-checklist-item ${esignedStatus ? "ready" : "pending"}`}>
          <div className="d-flex align-items-center gap-3">
            <div className={`rounded-circle p-2 d-flex align-items-center justify-content-center ${esignedStatus ? "bg-success text-white" : "bg-warning text-dark"}`} style={{ width: "32px", height: "32px" }}>
              <i className={`fa-solid ${esignedStatus ? "fa-check" : "fa-clock"}`}></i>
            </div>
            <div>
              <span className="fw-bold d-block" style={{ fontSize: "14px" }}>Aadhaar eSign Signature</span>
              <span className="text-muted small">{esignedStatus ? "Document electronically signed" : "Verify identity via Aadhaar OTP eSign"}</span>
            </div>
          </div>
          {!esignedStatus && agreementGenerated && (
            <button className="oxy-btn-primary py-2 px-3 btn-sm" onClick={onEsign}>
              Sign Now
            </button>
          )}
        </div>

        {/* Step 3: eNACH */}
        <div className={`doc-checklist-item ${enachStatus ? "ready" : "pending"}`}>
          <div className="d-flex align-items-center gap-3">
            <div className={`rounded-circle p-2 d-flex align-items-center justify-content-center ${enachStatus ? "bg-success text-white" : "bg-warning text-dark"}`} style={{ width: "32px", height: "32px" }}>
              <i className={`fa-solid ${enachStatus ? "fa-check" : "fa-clock"}`}></i>
            </div>
            <div>
              <span className="fw-bold d-block" style={{ fontSize: "14px" }}>eNACH Auto-Debit Mandate</span>
              <span className="text-muted small">{enachStatus ? "Auto-debit successfully linked" : "Link bank account for automatic EMI auto-pay"}</span>
            </div>
          </div>
          {!enachStatus && esignedStatus && (
            <button className="oxy-btn-primary py-2 px-3 btn-sm" onClick={onEnach}>
              Link Auto-Pay
            </button>
          )}
        </div>
      </div>

      <div className="border-top pt-4 mt-4 text-center">
        {esignedStatus && enachStatus ? (
          <div className="alert alert-success d-flex align-items-center gap-2 mb-0 justify-content-center">
            <i className="fa-solid fa-circle-check"></i>
            <span>All documentation completed! Your loan is ready for disbursement.</span>
          </div>
        ) : (
          <span className="text-muted small">
            <i className="fa-solid fa-shield-halved me-1"></i>
            Secured via NSDL eSign and NPCI eNACH gateways.
          </span>
        )}
      </div>
    </div>
  );
};

export default DocumentChecklist;
